import React from "react";
import { useSelector } from "react-redux";
import { Menu } from "antd";
import { Link, useHistory } from "react-router-dom";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL
} from "../../constants/ThemeSetting";


const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;

const getMenuPathKey = value => typeof value === 'string'
  ? value.split('?')[0].replace(/^\/+/, '')
  : '';

const HorizontalNav = () => {

  const history = useHistory();
  const navStyle = useSelector(({ settings }) => settings.navStyle);
  //const pathname = useSelector(({ settings }) => settings.pathname);
  const pathname = useSelector(({ common }) => common.pathname);
  const navBarItems = useSelector(({ settings }) => settings.NavBarItems);

  const getNavStyleSubMenuClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-inside-submenu-popup-curve";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-below-submenu-popup-curve";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-above-submenu-popup-curve";
      default:
        return "gx-menu-horizontal";

    }
  };

  const selectedKey = getMenuPathKey(pathname);

  return (
    <Menu
      selectedKeys={selectedKey ? [selectedKey] : []}
      mode="horizontal"
      subMenuOpenDelay={0}
      subMenuCloseDelay={0.1}
      className="gx-navigation-menu"
    >
      {
        navBarItems == null ? null :
          navBarItems.map(item => {
            return (
              <SubMenu key={`Module${item.moduleId}`} className={getNavStyleSubMenuClass(navStyle)}
                popupClassName={`${getNavStyleSubMenuClass(navStyle)} gx-navigation-submenu-popup`}
                title={item.moduleDisplay}>
                {
                  (item.imrTabsInterfaces || []).map((tab) => {
                    const moduleInterfaces = tab.moduleInterfaces || [];

                    return (
                      <Menu.ItemGroup
                        key={`Module${item.moduleId}Tab${tab.tabId}ItemGroup`}
                        title={<span className="gx-navigation-section-title"><i className="icon icon-widgets" />{tab.tabsDisplay}</span>}>
                        {
                          moduleInterfaces.map((interfa) => {
                            const hasParent = moduleInterfaces.some(
                              parent => parent.id === interfa.idInterfaceParent
                            );
                            if (hasParent) return null;

                            const children = moduleInterfaces.filter(
                              (x) => x.idInterfaceParent === interfa.id && getMenuPathKey(x.url)
                            );

                            // If has children -> render SubMenu
                            if (children.length > 0) {
                              return (
                                <SubMenu
                                  key={`Interface${interfa.id}`}
                                  popupClassName="gx-navigation-submenu-popup"
                                  title={interfa.displayInterface}
                                >
                                  {children.map((child) => (
                                    <Menu.Item
                                      key={getMenuPathKey(child.url)}
                                      onClick={() => history.push(`${child.url}?I=${child.id}&T=${tab.tabId}&M=${item.moduleId}`)}
                                      //disabled={!child.hasAccess}
                                    >
                                      {child.displayInterface}
                                    </Menu.Item>
                                  ))}
                                </SubMenu>
                              );
                            }

                            // Otherwise -> render single Menu.Item
                            const menuKey = getMenuPathKey(interfa.url);
                            if (!menuKey) return null;

                            return (
                              <Menu.Item
                                key={menuKey}
                                //disabled={!interfa.hasAccess}
                              >
                                <Link
                                  to={`${interfa.url}?I=${interfa.id}&T=${tab.tabId}&M=${item.moduleId}`}
                                >
                                  {interfa.displayInterface}
                                </Link>
                              </Menu.Item>
                            );
                          })
                        }
                      </Menu.ItemGroup>
                    )
                  })
                }
              </SubMenu>
            )
          })
      }

    </Menu>

  );
};

HorizontalNav.propTypes = {};

export default HorizontalNav;

